export default __webpack_public_path__ + "static/media/Firma_Ornek_Excel.c1926cf4.xlsx";